<div class="container">
  <div class="row">
    <div class="col-md-12">
      <app-leader-board [game]="game"></app-leader-board>
    </div>
  </div>
  <div id="info">
    <h1>איך משחקים?</h1>
    <hr>
    <div>
      <p class="game-info-text" id="info_text"></p>
      <div class="flex-center" style="margin: 10px 0;">
        <div [ngClass]="{'map-help-icon': game.kind == 'match', 'replace': game.kind == 'trivia'}" class="div-img">
        </div>
        <p id="info_text_help1" class="game-info-help"></p>
      </div>
      <div class="flex-center" style="margin: 10px 0;">
        <div [ngClass]="{'color-help-icon': game.kind == 'match', 'half': game.kind == 'trivia'}" class="div-img">
        </div>
        <p id="info_text_help2" class="game-info-help"></p>
      </div>
      <p *ngIf="game.kind == 'match'" style="font-size: 24px; font-weight: 400; text-align: center; margin: 20px 0;">
        *חלון "הידעת?" ייפתח כל כמה תשובות נכונות, אל תדאגו השעון עוצר, קראו בנחת!</p>
    </div>
    <div id="start-game"
      [ngClass]="{'match-data-container': game.kind == 'match', 'trivia-data-container': game.kind == 'trivia'}"
      (click)="onStartGame()">
      <div class="white-circle">
        <img src="./assets/images/icons/play.png">
      </div>
      <h2>התחל</h2>
    </div>
    <div *ngIf="game.kind == 'match'" id="map-container" class="match-data-container" (click)="onOpenMap()">
      <div class="white-circle">
        <img src="./assets/images/icons/map.png">
      </div>
      <h2>מפה</h2>
    </div>
  </div>
  <div class="row" *ngIf="mapIsOpen">
    <div class="backdrop go-in" id="backdrop">
      <div class="map scale-in-pop" id="mapCont">
        <!-- <app-rails-map></app-rails-map> -->
        <img style="width: 100%;
        height: 100%;
        padding: 30px;" src="../../assets/images/backgrounds/rail-full.png">
        <button class="btn btn-danger" (click)="onCloseMap()">סגור</button>
      </div>
    </div>
  </div>
</div>
<app-count-down *ngIf="countDown"></app-count-down>
